export default (state, getters, rootState) => val => {
    let form = rootState.finances.pay.form;
    let sum = val.requests.reduce(function (sum, current) {
        return sum + (current.sum * 100);
    }, 0);
    sum = Math.round(sum) / 100;
    if (form.CurrencyId !== val.currency && form.CategoryId !== 2) sum = sum * val.course;

    return Math.round(sum * 100) / 100;
}